import { Component } from '@angular/core'

import { environment } from '../../../environments/environment'
import { BreadcrumbService } from '../../common/services/breadcrumb.service'
import { MetaService } from '../../common/services/meta.service'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  isAlt: boolean = environment.isAltVersion

  constructor(breadcrumbService: BreadcrumbService, metaService: MetaService) {
    breadcrumbService.breadcrumbLinks.next([])
    metaService.setTags({
      title: 'Accueil',
      path: ''
    })
  }
}
